import StsA360RegStep1AnswerInfoModel
  from './sts-a360-reg-step1-answer-info.model';


export default class StsA360RegistrationResponseModel {

  success: boolean;
  errors: string[];
  stsCode: string;
  info: StsA360RegStep1AnswerInfoModel;
  'sts-code': string;
  useEmailOnFileForRegistration: boolean;
}
